const VerificationCodeStatus = {
  none: 0,
  unsuccess: 1, // code does not match
  success: 2,
  expired: 3,
  maxAttemptsExceeded: 4,
  invalidPhoneNumber: 5,
  maxCodeRequestAttemptsExceeded: 6,
};

export default VerificationCodeStatus;
